import moment from 'moment';
import { Card, Col, Row } from 'reactstrap';

const DaysComponent = ({ data }) => {
  const currentDate = moment();
  const createdAt = moment(data.createdAt);
  const diff = currentDate.diff(createdAt, 'days');

  return (
    <Card body>
      <Row>
        <Col md={12} className="mb-3">
          <div
            className="text-center"
            style={{
              fontWeight: 600,
              fontSize: 16
            }}
          >
            Tienes <span style={{ color: '#7367F0' }}>{diff}</span> días en
            Subliful
          </div>
        </Col>
        <Col md={12} className="mb-2">
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 14,
              fontWeight: 600
            }}
          >
            Puntos por Pilar
          </div>
        </Col>
        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.pillars.emotions}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Emociones
          </div>
        </Col>
        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.pillars.relations}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Relaciones
          </div>
        </Col>
        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.pillars.transformation}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Transformacion
          </div>
        </Col>
        <Col md={2} />
        <Col className="mt-2" md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.pillars.transformation}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Sentido de la vida
          </div>
        </Col>
        <Col className="mt-2" md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.pillars.selfEsteem}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Amor Propio
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default DaysComponent;
